const dueesurvey = {
    pages: [{
      elements: [{
          type: "html",
          name: "image1",
          html: "<div class='survey-div'><img class='survey-img' alt='domanda1' src='./images/domanda1.jpg'></div>"},
        { 
          name: "1",
          title: "Quanti vestiti hai nel tuo armadio che non usi da più di un anno ?",
          type: "radiogroup",
          choices: [
              { value: 1, text: " Meno di 5" },
              { value: 3, text: " Tra 5 e 15" },
              { value: 5, text: " Più di 15" },
          ],
          requiredErrorText: "Seleziona una risposta",
          isRequired: true
      }]
    }, {
      elements: [{
        type: "html",
        name: "image2",
        html: "<div class='survey-div'><img class='survey-img' alt='domanda2' src='./images/domanda2.jpg'></div>"},
      {
          name: "2",
          title: "In media, quanti capi di abbigliamento compri in un mese?",
          type: "radiogroup",
          choices: [
            { value: 1, text: "  Nessuno o solo quando necessario" },
            { value: 3, text: "  2 - 3 capi" },
            { value: 5, text: "  4 o più capi" },
          ],
          requiredErrorText: "Seleziona una risposta",
          isRequired: true,
        }]
      },{elements: [{
        type: "html",
        name: "image3",
        html: "<div class='survey-div'><img class='survey-img' alt='domanda3' src='./images/domanda3.jpg'></div>"},
      {
          name: "3",
          title: "Cosa fai con gli indumenti che non usi più?",
          type: "radiogroup",
          choices: [
              { value: 1, text: "  Li dono o li vendo" },
              { value: 3, text: "  Li tengo inutilizzati nell'armadio" },
              { value: 5, text: "  Li butto via" },
          ],
          requiredErrorText: "Seleziona una risposta",
          isRequired: true,
        }]
      },{elements: [{
        type: "html",
        name: "image4",
        html: "<div class='survey-div'><img class='survey-img' alt='domanda4' src='./images/domanda4.jpg'></div>"},
      {
          name: "4",
          title: "Sai quanta energia serve per produrre una T-shirt di cotone?",
          type: "radiogroup",
          choices: [
              { value: 1, text: "  Sì" },
              { value: 3, text: "  Ho un'idea generica ma non i numeri esatti" },
              { value: 5, text: "  No, non ne ho idea" },
          ],
          requiredErrorText: "Seleziona una risposta",
          isRequired: true,
        }]
      },{elements: [{
        type: "html",
        name: "image5",
        html: "<div class='survey-div'><img class='survey-img' alt='domanda5' src='./images/domanda5.jpg'></div>"},
      {
          name: "5",
          title: "Con che frequenza lavi i tuoi jeans?",
          type: "radiogroup",
          choices: [
              { value: 1, text: "  Dopo almeno 5 utilizzi" },
              { value: 3, text: "  Dopo 2 - 3 utilizzi" },
              { value: 5, text: "  Dopo ogni utilizzo" },
          ],
          requiredErrorText: "Seleziona una risposta",
          isRequired: true,
        }]
      },{elements: [{
        type: "html",
        name: "image6",
        html: "<div class='survey-div'><img class='survey-img' alt='domanda6' src='./images/domanda6.jpg'></div>"},
      {
          name: "6",
          title: "Come asciughi i tuoi vestiti?",
          type: "radiogroup",
          choices: [
              { value: 1, text: "  Stendendoli all'aperto" },
              { value: 3, text: "  Un pò stesi, un pò in asciugatrice" },
              { value: 5, text: "  Uso sempre l'asciugatrice" },
          ],
          requiredErrorText: "Seleziona una risposta",
          isRequired: true,
        }]
      },{ elements: [{
        type: "html",
        name: "image7",
        html: "<div class='survey-div'><img class='survey-img' alt='domanda7' src='./images/domanda7.jpg'></div>"},
      {
          name: "7",
          title: "Hai mai partecipato a uno swap party o acquistato second-hand?",
          type: "radiogroup",
          choices: [
              { value: 1, text: "  Sì, regolarmente!" },
              { value: 3, text: "  Qualche volta" },
              { value: 5, text: "  No, mai" },
          ],
          requiredErrorText: "Seleziona una risposta",
          isRequired: true,
        }]
      },{elements: [{
        type: "html",
        name: "image8",
        html: "<div class='survey-div'><img class='survey-img' alt='domanda8' src='./images/domanda8.jpg'></div>"},
      {
          name: "8",
          title: "Quando compri un capo di abbigliamento, guardi la composizione del tessuto?",
          type: "radiogroup",
          choices: [
              { value: 1, text: "  Sì, cerco materiali sostenibili" },
              { value: 3, text: "  A volte, se ho tempo" },
              { value: 5, text: "  No, non ci faccio caso" },
          ],
          isRequired: true,
          requiredErrorText: "Seleziona una risposta"
        }]
      },{elements: [{
        type: "html",
        name: "image9",
        html: "<div class='survey-div'><img class='survey-img' alt='domanda9' src='./images/domanda9.jpg'></div>"},
      {
          name: "9",
          title: "Ti è mai capitato di comprare un indumento e di non indossarlo mai?",
          type: "radiogroup",
          choices: [
              { value: 1, text: "  No, scelgo sempre con cura" },
              { value: 3, text: "  Qualche volta" },
              { value: 5, text: "  Spesso, ho ancora capi con l’etichetta!" },
          ],
          isRequired: true,
          requiredErrorText: "Seleziona una risposta"
        }]
      },{elements: [{
        type: "html",
        name: "image10",
        html: "<div class='survey-div'><img class='survey-img' alt='domanda10' src='./images/domanda10.jpg'></div>"},
      {
          name: "10",
          title: "Cosa fai quando un vestito si rovina o ha qualche piccola lacerazione?",
          type: "radiogroup",
          choices: [
              { value: 1, text: "  Lo riparo o lo faccio sistemare" },
              { value: 3, text: "  Lo metto da parte e forse lo userò come straccio per la casa" },
              { value: 5, text: "  Lo butto e ne compro uno nuovo" },
          ],
          isRequired: true,
          requiredErrorText: "Seleziona una risposta"
        }]
      }],
      completedHtml: "<p>Grazie per il tuo tempo!</p><p>calcolo il tuo livello di spreco energetico</p> ",
      pageNextText: "Avanti",
      completeText: "Invia",
      pagePrevText: "Precedente",    
  }

  const pagea = {
    elements: [{
      type:"html",
      name:"pagea",
      html:"<h1>Compliemnti!</h1>"
    }],
    showNavigationButtons: "none"
  }
  const pageb = {
    elements: [{
      type:"html",
      name:"pageb",
      html:"<h1>pageb</h1>"
    }],
    showNavigationButtons: "none"
  }
  const pagec = {
    elements: [{
      type:"html",
      name:"pagec",
      html:"<h1>pagec</h1>"
    }],
    showNavigationButtons: "none"
  }

export {dueesurvey,pagea,pageb,pagec};